import { styled, Tab, Tabs } from "@mui/material";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import NotificationsIcon from "@mui/icons-material/Notifications";
import React from "react";
import OtherServiceBooking from "./otherServiceBooking/otherServiceBooking";
import OtherServiceAlert from "./otherServiceAlert/otherServiceAlert";
const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
};

const OtherServices = () => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const StyledTab = styled(Tab)({
    "&.Mui-selected": {
      color: "#ff4d4d",
    },
  });
  return (
    <>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="icon label tabs example"
        TabIndicatorProps={{
          style: {
            backgroundColor: "#ff4d4d",
          },
        }}
      >
         <StyledTab
          sx={{ textTransform: "none" }}
          icon={<NotificationsIcon />}
          iconPosition="start"
          label="Service Alert"
        />
        <StyledTab
          sx={{ textTransform: "none" }}
          icon={<WorkHistoryIcon />}
          iconPosition="start"
          label="Booking History"
        />
       
      </Tabs>
      <TabPanel value={value} index={0}>
      <OtherServiceAlert/>
      </TabPanel>
      <TabPanel value={value} index={1}>
      <OtherServiceBooking/>
      </TabPanel>
    </>
  );
};

export default OtherServices;
